import { unescape } from 'lodash';
import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
import { gzipToBase64 } from '../compression/GZipCompressor';
import LZString from 'lz-string';

// const baseUrl = APISettings.apiUrl;
const baseUrl = new APISettings().getApiURL();

class ChapterApi<Chapter> extends BaseAPI {
  // constructor() {}

  public getChapterById: (id: number) => Promise<Chapter[]> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/chapter/${id}`)).data.output;
  };

  public getChaptersByTitleId: (id: number) => Promise<Chapter[]> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/chapter/GetByTitleId/${id}`)).data.output;
  };


  public updateChapter: (chapter: any) => Promise<Chapter> = async (chapter: any) => {
    const encodedChapterHtml = await gzipToBase64(chapter.chapterHtml);
    const encodedChapterName = btoa(unescape(encodeURIComponent(chapter.chapterName)));
    const encodedChapter = { ...chapter, chapterHtml: encodedChapterHtml, chapterName: encodedChapterName };

    return (await BaseAPI.axios.put(`${baseUrl}/chapter`, encodedChapter)).data.output;
  };

  public recreatePdf: (id: number) => Promise<string> = async (id: number) => {
    let blobName = (await BaseAPI.axios.get(`${baseUrl}/chapter/${id}/recreatePdf`)).data.message;
    return blobName;
  }
}

export const chapterAPI = new ChapterApi();
